export const TUVIS_MESSAGE_SOURCES = [
  "desktop",
  "sidecar",
  "extension",
  "slack",
  "tuvisTeamsApp",
  "wabaWeb",
  "archive",
  "tuvisBrowser",
  "tuvis_messaging",
] as const;
export type TuvisMessageSource = (typeof TUVIS_MESSAGE_SOURCES)[number];

export type IncidentApplicationKey = "desktop" | "extension" | "external";

export const getIncidentApplicationKey = (source: TuvisMessageSource): IncidentApplicationKey => {
  switch (source) {
    case "desktop":
      return "desktop";
    case "extension":
    case "tuvisBrowser":
      return "extension";
    default:
      return "external";
  }
};

const INCIDENT_APPLICATION_TEXT = { desktop: "Tuvis Desktop", extension: "Tuvis Extension", external: "External" } as const;
export type IncidentApplication = (typeof INCIDENT_APPLICATION_TEXT)[IncidentApplicationKey];

export const getIncidentApplicationToText = (source: TuvisMessageSource): IncidentApplication =>
  INCIDENT_APPLICATION_TEXT[getIncidentApplicationKey(source)];
